import { ContractTemplate } from '../../lib/types/models/contract-template/contract-template'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getContractTemplate(id: number) {
  return restApiClient
    .url(constructApiUrl(API.contractTemplate.get.url, { id }))
    .get<ContractTemplate>()
}
